import { __decorate } from "tslib";
import { computed, observable, runInAction } from 'mobx';
export default class Transport {
    constructor(props = {}, dataSet) {
        runInAction(() => {
            this.props = props;
            this.dataSet = dataSet;
        });
    }
    set create(create) {
        runInAction(() => {
            this.props.create = create;
        });
    }
    get create() {
        return this.props.create;
    }
    set read(read) {
        runInAction(() => {
            this.props.read = read;
        });
    }
    get read() {
        return this.props.read || this.dataSet.queryUrl;
    }
    set update(update) {
        runInAction(() => {
            this.props.update = update;
        });
    }
    get update() {
        return this.props.update;
    }
    set destroy(destroy) {
        runInAction(() => {
            this.props.destroy = destroy;
        });
    }
    get destroy() {
        return this.props.destroy;
    }
    set validate(validate) {
        runInAction(() => {
            this.props.validate = validate;
        });
    }
    get validate() {
        return this.props.validate || this.dataSet.validateUrl;
    }
    set submit(submit) {
        runInAction(() => {
            this.props.submit = submit;
        });
    }
    get submit() {
        return this.props.submit || this.dataSet.submitUrl;
    }
    set exports(exports) {
        runInAction(() => {
            this.props.exports = exports;
        });
    }
    get exports() {
        return this.props.exports || this.dataSet.exportUrl;
    }
    set tls(tls) {
        runInAction(() => {
            this.props.tls = tls;
        });
    }
    get tls() {
        return this.props.tls || this.dataSet.tlsUrl;
    }
    set adapter(adapter) {
        runInAction(() => {
            this.props.adapter = adapter;
        });
    }
    get adapter() {
        return this.props.adapter;
    }
}
__decorate([
    observable
], Transport.prototype, "props", void 0);
__decorate([
    computed
], Transport.prototype, "create", null);
__decorate([
    computed
], Transport.prototype, "read", null);
__decorate([
    computed
], Transport.prototype, "update", null);
__decorate([
    computed
], Transport.prototype, "destroy", null);
__decorate([
    computed
], Transport.prototype, "validate", null);
__decorate([
    computed
], Transport.prototype, "submit", null);
__decorate([
    computed
], Transport.prototype, "exports", null);
__decorate([
    computed
], Transport.prototype, "tls", null);
__decorate([
    computed
], Transport.prototype, "adapter", null);
